module.exports = __webpack_public_path__ + "static/media/de.69ccebc7.svg";